// Rótulos conferidos em 27/10/2026 contra o leiaute eSocial S-1.3 (NT 06/2026, rev. 09/04/2026), gov.br/esocial:
// Tabelas 01 e 19 e domínios de grauInstr e tpJornada. Grupos de afastamento (Tabela 18) são agrupamento nosso, sem rótulo oficial.
import { FAIXAS, Grupo, Variavel } from "./types";

/** Grupos de afastamento (C.9 e R3), na ordem em que aparecem na tabela. */
export const GRUPO_AFASTAMENTO: Record<Grupo, string> = {
  maternidade: "Licença-maternidade",
  doencaAte15: "Doença ou acidente fora do trabalho, até 15 dias",
  doencaInss: "Doença ou acidente fora do trabalho, pelo INSS",
  acidenteTrabalho: "Acidente ou doença do trabalho",
  outros: "Outros motivos",
};

/** Rótulo do mapa, com ou sem zero à esquerda; código fora do mapa aparece como "código N" (critério 19). */
export const rotuloOuCodigo = (mapa: Record<string, string>, codigo: string): string =>
  mapa[codigo] ?? mapa[codigo.padStart(2, "0")] ?? `código ${codigo}`;

/** Tabela 19 do leiaute S-1.3 (motivo de desligamento). Código em dúvida fica fora e cai em "código N". */
export const MOTIVO_DESLIGAMENTO: Record<string, string> = {
  "01": "Justa causa",
  "02": "Sem justa causa",
  "03": "Fim antecipado do contrato a termo, pela empresa",
  "04": "Fim antecipado do contrato a termo, pela pessoa",
  "05": "Culpa recíproca",
  "06": "Fim do contrato a termo",
  "07": "Pedido de demissão",
  "10": "Falecimento",
  "17": "Rescisão indireta",
  "33": "Acordo",
};

/** Uma linha por variável do catálogo (C.13: variável nova = backend, Airflow, e por último uma linha aqui).
 *  Categoria (Tabela 01), grauInstr e tpJornada conferidos no leiaute S-1.3; código em dúvida fica fora e cai em "código N". */
export const CATALOGO_COMPOSICAO: { variavel: Variavel; nome: string; rotulos: Record<string, string>; ordem?: readonly string[] }[] = [
  {
    variavel: "categoria",
    nome: "Categoria",
    rotulos: { "101": "CLT", "103": "Aprendiz", "104": "Doméstico", "105": "Contrato a termo (Lei 9.601/98)", "106": "Temporário", "111": "Intermitente" },
  },
  {
    variavel: "tipoDeContrato",
    nome: "Tipo de contrato",
    rotulos: { indeterminado: "Prazo indeterminado", ate90Dias: "Até 90 dias (em geral, de experiência)", outrosPrazos: "Outros prazos" },
    ordem: ["indeterminado", "ate90Dias", "outrosPrazos"],
  },
  { variavel: "sexo", nome: "Sexo", rotulos: { M: "Masculino", F: "Feminino" } },
  { variavel: "faixaEtaria", nome: "Faixa etária", rotulos: Object.fromEntries(FAIXAS.map((f) => [f, f])), ordem: FAIXAS },
  {
    variavel: "tempoDeCasa",
    nome: "Tempo de casa",
    rotulos: { "<1": "Menos de 1 ano", "1-2": "1 a 2 anos", "2-5": "2 a 5 anos", "5-10": "5 a 10 anos", "10+": "Mais de 10 anos" },
    ordem: ["<1", "1-2", "2-5", "5-10", "10+"],
  },
  {
    variavel: "grauDeInstrucao",
    nome: "Grau de instrução",
    rotulos: {
      "01": "Analfabeto",
      "02": "Fundamental até o 5º ano incompleto",
      "03": "5º ano completo",
      "04": "6º ao 9º ano incompleto",
      "05": "Fundamental completo",
      "06": "Médio incompleto",
      "07": "Médio completo",
      "08": "Superior incompleto",
      "09": "Superior completo",
      "10": "Pós-graduação completa",
      "11": "Mestrado completo",
      "12": "Doutorado completo",
    },
  },
  {
    variavel: "jornada",
    nome: "Jornada",
    rotulos: {
      "2": "12x36",
      "3": "Horário fixo, folga variável",
      "4": "Horário fixo, folga no domingo",
      "5": "Horário fixo, folga fixa fora do domingo",
      "6": "Horário fixo, folga fixa em outro dia e domingo periódico",
      "7": "Turno ininterrupto de revezamento",
      "9": "Outras jornadas",
    },
  },
];
